module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAaCAYAAABsONZfAAAAAXNSR0IArs4c6QAAAJdJREFUOE/tlEEKAjEMRZP84lo9oN7AcaOHcOXMEeaCdW1JKjoVxkKgK1ftppSfR+jn8znnvDGzGxEdaDmziFyZ+elqqnonoqEA32sEcPY0VtVIRNsKegDYeZoHRQB7B4qcUhpF5FRtmgAMnsarzx7foJnNIYRLZcSvVm1oenLTVDX0R6gn4uP91BNRMrg2ondEKcvmjngBYWrsu6yGxLgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/drag-icon-s.png
// module id = TwQW
// module chunks = 54